import tw, { styled } from 'twin.macro';

export const CloseModalButton = styled.button`
  ${tw`absolute top-0 right-0`}
`;

export const CloseVideoModalButton = styled.button`
  ${tw`absolute -top-[44px] sm:-top-[36px] right-0 sm:-right-[36px]`}
  ${tw`rounded-full`}
`;
